export default __webpack_public_path__ + "static/media/evo_banner_highlight.8d0e22b7.png";